import React from 'react'
import styles from './styles.module.css' // Ensure this is the correct path to your CSS module
import Tooltip from '@mui/material/Tooltip'
import infoIcon from '../Images/circle-info-regular-full.svg'

function RecordRecency ({ localRecordRecency, setLocalRecordRecency }) {
  const today = new Date()
  const maxDate = `${today.getFullYear()}-${String(
    today.getMonth() + 1
  ).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`

  const handleDateAddedChange = e => {
    setLocalRecordRecency({
      ...localRecordRecency,
      dateAdded: e.target.value
    })
  }

  const handleDateUpdatedChange = e => {
    setLocalRecordRecency({
      ...localRecordRecency,
      dateUpdated: e.target.value
    })
  }

  return (
    <div className={styles.RecordRecencyContainer}>
      <h1 className={styles.RecordRecencyTitle}>Record recency</h1>

      <div className={styles.FlexContainer}>
        <div className={styles.FlexColumn}>
          {/* Label + Tooltip */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              marginBottom: '8px'
            }}
          >
            <span className={styles.RecordRecencyLabel}>Date added</span>
            <Tooltip
              title='Filters to records first added on or after this date.'
              arrow
              placement='top'
              slotProps={{
                popper: {
                  sx: {
                    '& .MuiTooltip-tooltip': {
                      maxWidth: 500,
                      fontSize: '13px',
                      padding: '8px'
                    }
                  }
                }
              }}
            >
              <img
                src={infoIcon}
                alt='Date added help'
                width={14}
                height={14}
                style={{ cursor: 'pointer' }}
                tabIndex={0}
              />
            </Tooltip>
          </div>

          <input
            className={styles.RecordRecencyInput}
            type='date'
            name='dateAdded'
            max={maxDate}
            value={localRecordRecency.dateAdded}
            onChange={handleDateAddedChange}
            required
          />
        </div>

        <div className={styles.FlexColumn}>
          {/* Label + Tooltip */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              marginBottom: '8px'
            }}
          >
            <span className={styles.RecordRecencyLabel}>Date updated</span>
            <Tooltip
              title='Filters to records last updated on or after this date.'
              arrow
              placement='top'
              slotProps={{
                popper: {
                  sx: {
                    '& .MuiTooltip-tooltip': {
                      maxWidth: 500,
                      fontSize: '13px',
                      padding: '8px'
                    }
                  }
                }
              }}
            >
              <img
                src={infoIcon}
                alt='Date updated help'
                width={14}
                height={14}
                style={{ cursor: 'pointer' }}
                tabIndex={0}
              />
            </Tooltip>
          </div>

          <input
            className={styles.RecordRecencyInput}
            type='date'
            name='dateUpdated'
            max={maxDate}
            value={localRecordRecency.dateUpdated}
            onChange={handleDateUpdatedChange}
            required
          />
        </div>
      </div>
    </div>
  )
}

export default RecordRecency
